import React from 'react';
import { createGlobalStyle } from 'styled-components';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  body {\n    font-family: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var fontDefault = "'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";";
var Fonts = /*#__PURE__*/createGlobalStyle( /*#__PURE__*/_templateObject(), fontDefault);

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  /*\n    @reach/ui ignore warning for style not imported, we provide our own style\n    see: https://reacttraining.com/reach-ui/styling/\n   */\n\n  :root {\n    --reach-dialog: 1;\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var ReachUI = /*#__PURE__*/createGlobalStyle( /*#__PURE__*/_templateObject$1());

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n   /* Box sizing rules */\n    *,\n    *::before,\n    *::after {\n        box-sizing: border-box;\n    }\n\n    /* Remove default padding */\n    ul,\n    ol {\n        padding: 0;\n    }\n\n    /* Remove default margin */\n    body,\n    h1,\n    h2,\n    h3,\n    h4,\n    p,\n    ul,\n    ol,\n    figure,\n    blockquote,\n    dl,\n    dd {\n        margin: 0;\n    }\n\n    /* Set core root defaults */\n    html {\n        scroll-behavior: smooth;\n    }\n\n    /* Set core body defaults */\n    body {\n        min-height: 100vh;\n        text-rendering: optimizeSpeed;\n        line-height: 1.5;\n    }\n\n    /* Remove list styles on ul, ol elements with a class attribute */\n    ul,\n    ol {\n        list-style: none;\n    }\n\n    /* A elements that don't have a class get default styles */\n    a:not([class]) {\n        text-decoration-skip-ink: auto;\n    }\n\n    a {\n        text-decoration: none;\n    }\n\n    /* Make images easier to work with */\n    img,\n    picture {\n        max-width: 100%;\n        display: block;\n    }\n\n    /* Natural flow and rhythm in articles by default */\n    article > * + * {\n        margin-top: 1em;\n    }\n\n    /* Inherit fonts for inputs and buttons */\n    input,\n    button,\n    textarea,\n    select {\n        font: inherit;\n    }\n\n    /* Blur images when they have no alt attribute */\n    img:not([alt]) {\n        filter: blur(10px);\n    }\n\n    /* Remove all animations and transitions for people that prefer not to see them */\n    @media (prefers-reduced-motion: reduce) {\n        * {\n            animation-duration: 0.01ms !important;\n            animation-iteration-count: 1 !important;\n            transition-duration: 0.01ms !important;\n            scroll-behavior: auto !important;\n        }\n    }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
/*
 * styled-components version of modern-css-reset@1.1.1
 */


var Reset = /*#__PURE__*/createGlobalStyle( /*#__PURE__*/_templateObject$2());

var GlobalStyle = function GlobalStyle() {
  return React.createElement(React.Fragment, null, React.createElement(Reset, null), React.createElement(ReachUI, null), React.createElement(Fonts, null));
};

export { Fonts, GlobalStyle, ReachUI, Reset, fontDefault };